import { APPLICATION_IMPORTANCE_LIST } from '../../../../ng/components/jenkins-controller/legacy-constants'
import { JiraIntegrationForm } from './jira-form-schema'

export const JiraFormFieldTypes = {
  SERVERLESS: 'serverless',
  PROJECT: 'project',
  CREDENTIALS: 'credentials',
  CREDENTIALS_ID: 'credentials_id',
  CREDENTIALS_NAME: 'credentials.name',
  CREDENTIALS_HOST: 'credentials.host',
  CREDENTIALS_PASSWORD: 'credentials.password',
  CREDENTIALS_USERNAME: 'credentials.username',
  PROJECT_FIELDS: 'fields',
  ASSIGNEE: 'assignee',
  ISSUE_TYPE: 'issue_type',
  APPLICATIONS: 'applications',
  PRIORITY_FIELD_AVAILABLE: 'priority_field_available',
  PRIORITY_HIGH: 'priority_high',
  PRIORITY_MEDIUM: 'priority_medium',
  PRIORITY_CRITICAL: 'priority_critical',
  PRIORITY_LOW: 'priority_low',
  PRIORITY_NOTE: 'priority_note',
  APP_CRITERION: 'app_criterion',
  ALL_APPLICATIONS: 'all_applications',
  APPLICATION_IMPORTANCE: 'importance',
  SERVERLESS_ACCOUNT_IDS: 'serverless_account_ids',
  SERVERLESS_CATEGORIES: 'serverless_categories',
  AUTO_CREATE_TICKETS_SEVERITIES: 'auto_create_tickets_severities',
  AUTO_CREATE_TICKETS_RULES: 'auto_create_tickets_rules',
  AUTO_CREATE_TICKETS_ENABLED: 'auto_create_tickets_enabled',
  INTEGRATION: 'integration',
  URL: 'url',
  EPIC_ID: 'epic_id',
  EXCLUDE_SENSITIVE_INFO: 'exclude_sensitive_info',
  SEND_TAGS: 'send_tags',
  MAINTENANCE_WINDOW: 'maintenance_windows'
} as const

export const DEFAULT_AUTO_CREATE_TICKETS_SEVERITIES = ['CRITICAL', 'HIGH']

export const DEFAULT_PRIORITY_VALUES = {
  priority_critical: 'Critical',
  priority_high: 'Critical',
  priority_medium: 'Major',
  priority_low: 'Standard',
  priority_note: 'Standard'
}
export const formDefaultValues: Partial<JiraIntegrationForm> = {
  serverless: false,
  ...DEFAULT_PRIORITY_VALUES,
  assignee: {
    displayName: 'Unassigned',
    active: true,
    timeZone: '',
    locale: '',
    accountId: '-1',
    key: '-1',
    emailAddress: '',
    name: ''
  },
  applications: [],
  app_criterion: true,
  importance: [...APPLICATION_IMPORTANCE_LIST],
  serverless_account_ids: [],
  serverless_categories: [],
  auto_create_tickets_severities: DEFAULT_AUTO_CREATE_TICKETS_SEVERITIES,
  auto_create_tickets_rules: [],
  auto_create_tickets_enabled: false
}
